// ช่องกรอกตัวเลข limit ในตาราง what-if — เก็บ draft เป็น string ระหว่างพิมพ์ (ลบจนว่างไม่เด้งเป็น 0)
// commit เฉพาะเมื่อ parse ได้ (clamp ตามช่วง) · blur แล้วคืนเป็นค่าจริงเสมอ
import React, { useEffect, useState } from 'react';
import { clampInt } from './capacityMath';

export const LIMIT_INPUT_CLASS =
  'w-24 px-2 py-1.5 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200 rounded-lg text-sm text-right font-semibold tabular-nums focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-slate-600 focus:border-gray-400 dark:focus:border-slate-500 disabled:opacity-50 disabled:cursor-not-allowed';

interface LimitInputProps {
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
  title?: string;
  ariaLabel?: string;
  onCommit: (v: number) => void;
}

const LimitInput: React.FC<LimitInputProps> = ({ value, min, max, disabled = false, title, ariaLabel, onCommit }) => {
  const [draft, setDraft] = useState(String(value));
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setDraft(String(value));
  }, [value, focused]);

  return (
    <input
      type="number"
      inputMode="numeric"
      min={min}
      max={max}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
      value={draft}
      className={LIMIT_INPUT_CLASS}
      onChange={(e) => {
        const raw = e.target.value;
        setDraft(raw);
        if (raw === '') return;
        const n = parseInt(raw, 10);
        if (Number.isFinite(n)) onCommit(clampInt(n, min, max));
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false);
        setDraft(String(value));
      }}
    />
  );
};

export default LimitInput;
